import { Reveal } from "@/components/landing/Reveal";
import {
  SiGooglecalendar,
  SiGmail,
  SiFitbit,
  SiGarmin,
  SiNotion,
  SiSpotify,
  SiApple,
} from "react-icons/si";
import { Calendar, HeartPulse, Activity, Linkedin, CircleDot } from "lucide-react";

const integrations = [
  { name: "Google Calendar", Icon: SiGooglecalendar },
  { name: "Apple Calendar", Icon: Calendar },
  { name: "Gmail", Icon: SiGmail },
  { name: "Apple Health", Icon: HeartPulse },
  { name: "Fitbit", Icon: SiFitbit },
  { name: "Garmin", Icon: SiGarmin },
  { name: "Oura", Icon: CircleDot },
  { name: "Whoop", Icon: Activity },
  { name: "LinkedIn", Icon: Linkedin },
  { name: "Notion", Icon: SiNotion },
  { name: "Spotify", Icon: SiSpotify },
  { name: "Apple", Icon: SiApple },
];

const Row = () => (
  <>
    {integrations.map((it) => {
      const Icon = it.Icon;
      return (
        <div
          key={it.name}
          className="mx-3 flex shrink-0 items-center gap-3 rounded-full border border-white/10 bg-[#0C0C0E] px-6 py-3.5"
        >
          <Icon className="h-5 w-5 text-white/80" />
          <span className="whitespace-nowrap text-sm font-medium text-white">
            {it.name}
          </span>
        </div>
      );
    })}
  </>
);

export const Integrations = () => {
  return (
    <section data-testid="integrations" className="relative overflow-hidden py-28">
      <div className="mx-auto max-w-2xl px-6 text-center lg:px-8">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gradient">
            Built Around Your Life
          </p>
          <h2 className="mt-5 font-mega text-4xl leading-[0.95] text-white sm:text-5xl lg:text-6xl">
            Works With The Tools You Already Use
          </h2>
        </Reveal>
      </div>

      <div className="relative mt-16">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-32 bg-gradient-to-r from-[#050505] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-32 bg-gradient-to-l from-[#050505] to-transparent" />
        <div className="flex w-max animate-marquee">
          <Row />
          <Row />
        </div>
      </div>
    </section>
  );
};

export default Integrations;
